<template>
  <div class="segmented" role="radiogroup" :aria-label="ariaLabel">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      role="radio"
      :aria-checked="modelValue === option.value ? 'true' : 'false'"
      :class="{ active: modelValue === option.value }"
      v-on:click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
// the grouping switch of the settings pages (as the delivery grouping of the sale channels)
export default {
  name: "SegmentedControl",
  props: {
    modelValue: [String, Number],
    options: { type: Array, required: true },
    ariaLabel: String,
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.segmented {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.25rem;
  background: #fff;
  border: 1px solid var(--pf-border);
  border-radius: 0.625rem;
}
.segmented button {
  min-height: 2.25rem;
  padding: 0 0.875rem;
  border: 0;
  border-radius: 0.5625rem;
  background: transparent;
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--pf-text);
}
.segmented button.active {
  background: var(--pf-accent);
  color: #fff;
}
</style>
